export default __webpack_public_path__ + "static/media/paymentGateway.527cc3be.svg";